import { Button, Modal } from "@scuf/common";
import { isNodeLinux, isNodeSim } from "../plantDetailUtils";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../features/store/action";

export const ConfirmModal = (props: any) => {
  const dispatch = useDispatch();

  return (
    <Modal
      size="small"
      closeIcon={true}
      className="confirmAction"
      onClose={() => {
        props.setCloseConfirmModal(false);
        props.handleClearAll();
        props.powerActionCancelled();
      }}
      open={props.closeConfirmModal}
      data-testid="plant-detail-confirm-modal"
      closeOnDimmerClick={false}
    >
      <Modal.Header>
        {props.header === "Create Snapshot" && props.snapShotList?.length === 3
          ? `Note`
          : `Confirm ${props.header}`}
      </Modal.Header>
      <Modal.Content className="contentAction">
        {props.header === "Power Off" && isNodeLinux(props.poweredVm)
          ? `! Power Off might require database restore for this controller!`
          : null}
        {props.header === "Shutdown" && isNodeSim(props.selectedVM)
          ? `! Shutdown might require database restore for SIM controller!`
          : null}
        <br />
        <br />
        {props.header === "Power On" ||
        props.header === "Power Off" ||
        props.header === "Restore Snapshot" ||
        props.header === "Delete Snapshot"
          ? `Are you sure you want to ${props.contentVal} Virtual Machines ?`
          : props.header === "Eject Media"
          ? `Are you sure you want to eject media from Virtual Machines ?`
          : props.header !== "Create Snapshot"
          ? `Are you sure you want to ${props.contentVal} one or more Virtual Machines ?`
          : null}
        {props.header === "Create Snapshot" && props.snapShotList?.length === 3
          ? `You have reached maximum limit of three snapshots.
               Please Delete atleast one existing snapshot to create a new one.`
          : props.header === "Create Snapshot" &&
            props.snapShotList?.length !== 3
          ? `Are you sure you want to ${props.contentVal} Virtual Machines ?`
          : null}
      </Modal.Content>
      <Modal.Footer>
        {props.header === "Create Snapshot" &&
        props.snapShotList?.length === 3 ? null : (
          <Button
            className="cancel-secondary"
            type="secondary"
            size="small"
            content="No"
            data-testid="plant-detail-confirm-no"
            onClick={() => {
              props.setCloseConfirmModal(false);
              props.handleClearAll();
              props.powerActionCancelled();
            }}
          />
        )}
        <Button
          className="save-secondary"
          type="primary"
          size="small"
          content={
            props.header === "Create Snapshot" &&
            props.snapShotList?.length === 3
              ? "OK"
              : "Yes"
          }
          data-testid="plant-detail-confirm-yes"
          onClick={() => {
            dispatch(setLoading(true));
            switch (props.header) {
              case "Restore Snapshot":
                props.restoreSnapShot();
                break;
              case "Create Snapshot":
                if (props.snapShotList?.length < 3) {
                  props.createSnapShot();
                } else {
                  props.handleClearAll();
                }
                break;
              case "Shutdown":
                props.handleShutDownClick();
                break;
              case "Power On":
                props.handlePowerOnClick();
                break;
              case "Power Off":
                props.handlePowerOffClick();
                break;
              case "Reset":
                props.handleResetClick();
                break;
              case "Eject Media":
                props.handleUnmountClick();
                break;
              case "Delete Snapshot":
                props.deleteSnapShot();
                break;
              default:
                break;
            }
            props.setCloseConfirmModal(false);
          }}
        />
      </Modal.Footer>
    </Modal>
  );
};

export const VMAlert = (props: any) => {
  return (
    <Modal
      size="small"
      closeIcon={true}
      className="confirmAction"
      onClose={() => {
        props.setClicked(false);
        props.setOpenVm(false);
      }}
      open={props.clicked}
      closeOnDimmerClick={false}
    >
      <Modal.Header>{`!Warning!`}</Modal.Header>
      <Modal.Content className="contentAction">
        Install antivirus software on the available nodes to ensure the optimum
        cyber security and protection.
        <br />
        <br />
        Please note the following :<br />
        1)Malware signature provided by antivirus vendor periodically, needs to
        be updated from time to time.
        <br />
        2)Failure to install & update will result into system shut down in order
        to maintain overall security
      </Modal.Content>
      <Modal.Footer>
        <Button
          className="cancel-secondary"
          type="secondary"
          size="small"
          content="cancel"
          onClick={() => {
            props.setClicked(false);
            props.setOpenVm(false);
          }}
        />
        <Button
          className="save-secondary"
          type="primary"
          size="small"
          content="confirm"
          onClick={() => {
            props.setOpenVm(true);
            props.setClicked(false);
          }}
        />
      </Modal.Footer>
    </Modal>
  );
};
